//ハッシュタグ スムーススクロール
var urlHash = location.hash;
if(urlHash) {
    $('body,html').stop().scrollTop(0);

    setTimeout(function(){
      var speed = 0;
      var href= $(this).attr("href");
      var target = $(urlHash);
      var position = target.offset().top;

      position -= $('.l-header').innerHeight();

      $("html, body").animate({scrollTop:position}, speed, "swing");
    }, 100);
}

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    position -= $('.l-header').innerHeight();

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function(){
  $('.p-hd__spMenu a').click(function(event) {
    $(this).toggleClass('is-on');
    $('.p-hd__navWrap').toggleClass('is-show');
  });
});

$(function(){
  $("p:has(iframe)").addClass("-iframeParent");
});

$(function(){
  const $gotop = $('.p-ft__gotop');

  if($gotop[0]) {
    $(window).on('scroll', function(event) {
      run();
    });

    const run = function() {
      if($(window).scrollTop() > 50) {
        $gotop.addClass('is-show');
      } else {
        $gotop.removeClass('is-show');
      }
    }
    run();
  }
})


$(function(){
  $('.js-outbound-world__btn').on('click', function(event) {
    $(this).fadeOut();
    $('.js-outbound-world__btnTarget').fadeIn();
  });
});

$(function(){
  $(window).on('scroll', function(event) {
    if($(window).scrollTop() > 10) {
      $('#wpadminbar').hide();
    } else {
      $('#wpadminbar').show();
    }
  });
});